export const environment = {
  production: true,
  environment: 'production',
  examInfoBackend: 'https://api.oncodata.com.br/api',
  slideManagerUrl: 'https://api.oncodata.com.br/api',
  ki67ServiceUrl: 'https://d2wzolqww0dycn.cloudfront.net',
  websocketEndpoint: 'wss://cry9ubyq28.execute-api.us-east-1.amazonaws.com',
  enableAi: true,
  enableKi67: true,
  enableProntuary: false,
  enableReport: true,
  enableDiscussion: true,
  enableAnnotation: true,
  enableRegisterCase: true,
  noPatientInfo: false,
  allowAnonymousRegister: false,
  sideSlideList: true,
  enableIntegrationLog: true,
  enableRuler: true,
  enableBarcode: true,
  enableRouteGuards: true,
  useLambdaTiles: true,
  enableImageDatabase: false,
  lambdaApiUrl: 'https://d3sbzunwzbby8c.cloudfront.net/slides/',
  lambdaMergedTilesApiUrl: 'https://d33hi09tdrvspj.cloudfront.net/slides/',
  lambdaMergedTilesPermanentApiUrl:
    'https://d1q2m4xgre8elm.cloudfront.net/slides/',
  tilegoSlideManagerUrl: 'https://api.oncodata.com.br',
  useTileGo: true,
};
